<template>
	<div>
		<div v-if="!addShow">
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">进场测算管理</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">
					<el-row>
						<!-- 左侧组织架构 -->
						<el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
							<Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
						</el-col>

						<!-- 右侧列表 -->
						<el-col :span="20">
							<el-row style="padding-left: 2%; padding-top: 40px;">
								<el-col :span="8">
									<span style="margin: 0 10px;">测算时间</span>
									<el-date-picker v-model="condition.create_time" type="daterange" range-separator="至"
										start-placeholder="开始日期" end-placeholder="结束日期" style="width:300px">
									</el-date-picker>
								</el-col>

								<el-col :span="5">
									<el-input v-model="condition.notes" style="margin-left:10px;width:220px"
										placeholder="请输入查询内容" clearable>
									</el-input>
								</el-col>

								<el-col :span="6">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Find">
										查询</el-button>
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Add">
										新增</el-button>
									<el-button
										style="width: 100px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Add">
										提交审核</el-button>
								</el-col>
							</el-row>

							<el-row style="margin: 0px 2%; margin-top: 20px;">

								<el-row>
									<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
										:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
										height="600" tooltip-effect="dark" style="width: 100%;"
										@selection-change="handleSelectionChange">
										<el-table-column type="selection" width="55">
										</el-table-column>
										<el-table-column align="center" label="序号" width="50">
											<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
										</el-table-column>
										<el-table-column prop="organizeName" align="center" label="架构">
										</el-table-column>
										<el-table-column prop="projectName" align="center" label="项目名称">
										</el-table-column>
										<el-table-column prop="sheetNumber" align="center" label="测算单编号" width="200">
										</el-table-column>
										<el-table-column prop="calculationDate" align="center" label="测算日期">
										</el-table-column>
										<el-table-column prop="accumulate" align="center" label="测算总金额">
										</el-table-column>
										<el-table-column prop="estimate_collection_amount" align="center" label="审核状态">
										</el-table-column>
										<el-table-column prop="tabulator" align="center" label="编制人">
										</el-table-column>
										<el-table-column prop="renewTime" align="center" label="最后修改时间">
										</el-table-column>
									</el-table>
								</el-row>
								<el-row style="margin-top: 10px; text-align: center;">
									<el-pagination background @current-change="handleCurrentChange"
										:page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
									</el-pagination>
								</el-row>
							</el-row>

						</el-col>
					</el-row>

				</div>
			</el-row>
		</div>
		<add ref="add" v-if="addShow" :ruleForm="ruleForm" :projectId="projectId" @return="Return"></add>
	</div>
</template>

<script>
	import Structure from "../utils/structure/structure.vue";
	import add from "./add.vue";

	import axios from "axios";
	export default {
		components: {
			Structure: Structure,
			add: add,
		},
		data() {
			return {
				//列表相关
				total: 0,
				tableData: [],
				addShow: false,
				projectId: '',
				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					project_id: '',
					create_time: '',
					renew_time: '',
					notes: '',
				},
				ruleForm: {},

				//复选框ids
				ids: [],
			};
		},
		methods: {
			//查询
			async Find() {
				var record = {
					page_num: this.condition.page_num,
					page_size: this.condition.page_size,
					project_id: this.condition.project_id,
					create_time: this.condition.create_time != null && this.condition.create_time != '' ?
						this.condition.create_time[0] : '',
					renew_time: this.condition.create_time != null && this.condition.create_time != '' ?
						this.condition.create_time[1] : '',
					notes: this.condition.notes,
				};
				var data = await this.$globals.AxiosPost('calculationSheet/gitList', record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
						this.projectId = this.condition.project_id;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async Add() {
				if (this.condition.project_id == '') {
					this.$message.warning('请先选择架构！');
				} else {
					var data = await this.$globals.AxiosGet('calculationSheet/generateCode');
					if (data === '-2000') {
						this.$message.error('服务器未响应！请稍后重试');
					} else {
						if (data.code === '200') {
							this.ruleForm = data.data;
						} else {
							this.$message.warning('请求失败！请稍后重试');
						}
						this.addShow = true;
					}
				}

			},
			Return() {
				this.addShow = false;
				this.Find();
			},
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val
				this.Find();
			},

		},
		async created() {
			this.Find();
		}
	}
</script>

<style scoped="scoped">
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-button--pic {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}

	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}

	>>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// Mobilization.vue?2f3fc04c